import { useState } from "react";
import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';
import { Dialog, DialogTitle, DialogContent, IconButton } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import Photo from "./Photo";
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { nord } from 'react-syntax-highlighter/dist/esm/styles/prism';


const AboutMe = () => {
  const [open, setOpen] = useState(false);
  const codeString = `georgii = WebDevEnthusiast(
    name="Georgii",  # or just Gosha/George
    is_student=True,
    fields_of_interest=["SWE", "BI/DS"],
    dark_mode_usage_percent=20,  # I like to see my bugs in the light
    is_dog_person=True,
)`;

  return (
    <div className="aboutMeContainer" id="aboutMe">
      <div className="aboutMe">
        <div className="aboutmeContent">
          <h1>About me</h1>
          <p>
            Hello, my name is{" "}
            <span
              data-tooltip-id="code-tooltip"
              data-tooltip-place="top"
              className="blue"
              onClick={() => setOpen(true)}
              style={{ cursor: "pointer", textDecoration: "none" }}
            >
              Georgii Mamaev
            </span>
            , and currently I am studying information technologies at the Faculty of Electrical Engineering of the CTU in Prague.
          </p>
          <p>At the moment, I am looking for a part-time job within the IT industry.</p>
          <p>I have a very strong desire to help others, so I would be very happy to use my knowledge of various technologies in projects that aim to help people.</p>
          <p>In my free time, I enjoy doing sports, my favorite one is basketball, and I'm pretty good at it. I also like watching movies and series, listening to music and learning foreign languages.</p>
        </div>

        {/* Tooltip */}
        <Tooltip id="code-tooltip" opacity={0.8}>
          Meet me, in code
        </Tooltip>

        {/* MUI Dialog */}
        <Dialog open={open} onClose={() => setOpen(false)} maxWidth="md">
          <DialogTitle>
            Meet me, in code
            <IconButton
              aria-label="close"
              onClick={() => setOpen(false)}
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent dividers>
            <pre style={{
              fontFamily: 'monospace',
            //   fontSize: '0.5rem',
              whiteSpace: 'pre-wrap',
            //   backgroundColor: '#1e1e1e',
              color: '#eee',
              padding: '1rem',
              borderRadius: '8px',
            }}>
            <SyntaxHighlighter language="python" style={nord}>
            {codeString}
          </SyntaxHighlighter>

            </pre>
          </DialogContent>
        </Dialog>
      </div>
      <Photo />
    </div>
  );
};

export default AboutMe;
